"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DeleteButton = void 0;
var PplAnalyticsEvent = _interopRequireWildcard(require("@ori-events/personal-product-list"));
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _auth = require("@ori/auth");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _presentationHooks = require("@ori/presentation-hooks");
var _router = require("next/router");
var _react = require("react");
var _constants = require("../../../../constants");
var _personalProductListEditContext = require("../../../../contexts/personalProductListEditContext");
var _hooks = require("../../../../hooks");
var _useTranslations = require("../../../../hooks/useTranslations");
var _DeleteConfirmationDialog = require("../DeleteConfirmationDialog");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
const DeleteButton = ()=>{
    const { translations } = (0, _useTranslations.useTranslations)();
    const { customerId } = (0, _auth.useToken)();
    const globalApiClient = (0, _globalApiClientReact.useApiClient)();
    const { personalProductListDetail: productList } = (0, _personalProductListEditContext.usePersonalProductListEditContext)();
    const { productListId, productListType } = (0, _hooks.useProductListParams)();
    const { push } = (0, _router.useRouter)();
    // TODO replace with useDisclose when it's available
    const { onClose, onOpen, open } = (0, _presentationHooks.useDisclose)();
    const onConfirm = (0, _react.useCallback)((listId)=>async ()=>{
            await (0, _globalApiClientReact.deleteCustomerProductListTypeProductList)(globalApiClient, customerId, productListType, listId);
            const listType = PplAnalyticsEvent.PersonalProductListType.Personal;
            var _productList_name, _productList_items_length;
            const event = new CustomEvent(PplAnalyticsEvent.Name, {
                detail: {
                    action: PplAnalyticsEvent.PersonalProductListAction.Delete,
                    listType,
                    listName: (_productList_name = productList === null || productList === void 0 ? void 0 : productList.name) !== null && _productList_name !== void 0 ? _productList_name : '',
                    listId,
                    itemsCount: (_productList_items_length = productList === null || productList === void 0 ? void 0 : productList.items.length) !== null && _productList_items_length !== void 0 ? _productList_items_length : 0
                }
            });
            window.dispatchEvent(event);
            onClose();
            await push(_constants.BASE_PATH);
        }, [
        globalApiClient,
        customerId,
        productListType,
        productList === null || productList === void 0 ? void 0 : productList.name,
        productList === null || productList === void 0 ? void 0 : productList.items.length,
        onClose,
        push
    ]);
    if (!productListId) {
        return null;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.IconButton, {
                "aria-label": translations.deleteIconLabel,
                component: "div",
                variant: "text",
                color: "default",
                onClick: onOpen,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_icons.Trashcan, {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_DeleteConfirmationDialog.DeleteConfirmationDialog, {
                isOpen: open,
                onConfirmation: onConfirm(productListId),
                onCancel: onClose
            })
        ]
    });
};
exports.DeleteButton = DeleteButton;
